import { BASE_API_URL } from 'lib/setting';
import { axs } from './config/axiosConfig';

const basePath = `${BASE_API_URL}/util`;

// "language":"EN"
export function fetchTeethIndicationFormat(payload: object | any) {
  return axs({
    url: `${basePath}/indication/format`,
    method: 'get',
    params: { version: 3, ...payload },
  });
}

export function fetchTeethIndicationInfo(payload: object | any) {
  return axs({
    url: `${basePath}/indication/info`,
    method: 'get',
    params: { version: 3, ...payload },
  });
}

export function fetchTeethIndicationOption(payload: object | any) {
  return axs({
    url: `${basePath}/indication/option`,
    method: 'get',
    params: { version: 3, ...payload },
  });
}

export function fetchTeethIndicationOptionOffline() {
  return axs({ url: `${basePath}/indication/option/offline`, method: 'get' });
}

export function fetchTeethImplantLibrary() {
  return axs({ url: `${basePath}/implantlibrary`, method: 'get' });
}

export function fetchAdvertisement() {
  return axs({ url: `${basePath}/advertisement`, method: 'get' });
}

export function fetchGoogleTranslate(payload: { text: string; target: string }) {
  return axs({ url: `${basePath}/translate`, method: 'get', params: payload });
}

export function fetchCurrencyList() {
  return axs({ url: `${basePath}/currency`, method: 'get' });
}

export function fetchCountryList() {
  return axs({ url: `${basePath}/country/list`, method: 'get' });
}

export function fetchCountryRegionList(payload: { country: number }) {
  return axs({ url: `${basePath}/country/region/list`, method: 'get', params: payload });
}

export function fetchLegalList(payload: { language: string }) {
  return axs({ url: `${basePath}/legal/agreement/list`, method: 'get', params: payload });
}

export function fetchLegalData(payload: { language: string; category: string }) {
  return axs({ url: `${basePath}/legal`, method: 'get', params: payload });
}

export function fetchLegalCategoryList() {
  return axs({ url: `${basePath}/legal/category`, method: 'get' });
}

export function fetchRemakeList(payload: { groupCode: string }) {
  return axs({ url: `${basePath}/remaketype/list`, method: 'get', params: payload });
}

export function fetchAdminNotification(payload: { language: string }) {
  return axs({ url: `${basePath}/notification`, method: 'get', params: payload });
}

export function fetchSupportLanguageList() {
  return axs({ url: `${basePath}/support/language`, method: 'get' });
}

export function fetchAdminTranslation(payload: { language: string }) {
  return axs({ url: `${basePath}/translation`, method: 'get', params: payload });
}

export function audioTranscription(payload: object | any) {
  return axs({ url: `${basePath}/transcription`, method: 'post', data: payload });
}

export function fetchUsertypeList(payload: object | any) {
  return axs({ url: `${basePath}/usertype/list`, method: 'get', data: payload });
}
